import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { usePageContext } from "../../../../../../components/navigation/PageContext";
import SurveyExpertContainer from "../../../../../../components/survey/SurveyExpertContainer";
import { SessionMode } from "../../../../../../store/session/slices";

import styles from "./survey.module.css";
import { useMeetingContainerAPI } from "../../../../../../hooks/meeting";

export const MeetingPedagogyInterventionSurveyPage = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const pageContextRef = useRefAutoUpdate(pageContext);

  const meetingContainerAPI = useMeetingContainerAPI(pageContextRef.current?.params?.id);

  return (
    <div className={styles.container}>
      <SurveyExpertContainer 
        meetingContainerAPI={meetingContainerAPI}
      />
    </div>
  );
};